import React, { useState } from 'react';
import { Button, Card, Col, message, Popconfirm, Row, Upload } from 'antd';
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ExportOutlined,
  FileTextFilled,
  ImportOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import './index.scss';
import EditApplication from './editModal';
import { useUpdate } from '@/common/hook';
import { deleteProcess, getProcessList, ProcessListVo, copyProcess } from '@/api/application';

const ApplicationList = () => {
  const [editData, setEditData] = useState<ProcessListVo>();
  const [visible, setVisible] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>();
  const [update, updateFn] = useUpdate();

  const { data, loading } = useRequest(getProcessList, { refreshDeps: [update] });

  const onCopy = (item: ProcessListVo) => {
    copyProcess({ id: item.id, name: `${item.name}（复制）` }).then(() => {
      updateFn();
    });
  };

  const onExport = (id: number) => {
    window.open(`/api/processDefinition/export?id=${id}`);
  };

  return (
    <div className="knowledge-container">
      <div className="flex gap-3 items-center mb-4">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => setVisible(true)}>
          创建应用
        </Button>
        <Upload
          name="file"
          action="/api/processDefinition/import"
          showUploadList={false}
          onChange={({ file }) => {
            console.log('file', file);
            if (file.response?.code === 0 && file.status === 'done') {
              updateFn();
            } else if (file.response?.code === 500 && file.status === 'done') {
              message.error('导入失败，请检查文件是否符合要求');
            }
          }}
        >
          <Button icon={<ImportOutlined />}>导入</Button>
        </Upload>
      </div>

      <Row gutter={8} className="mt-8 gap-y-2">
        {data?.map(item => (
          <Col
            span={6}
            key={item.id}
            onClick={e => {
              window.open(`/applicationList/edit/${item.id}`);
            }}
          >
            <Card
              loading={loading}
              actions={[
                <EditOutlined
                  key="edit"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    setEditData(item);
                    setVisible(true);
                  }}
                />,
                <CopyOutlined
                  key="copy"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onCopy(item);
                  }}
                />,
                <Popconfirm
                  title="确定删除该应用？"
                  onConfirm={e => {
                    e!.stopPropagation();
                    deleteProcess(item.id!).then(() => {
                      updateFn();
                    });
                  }}
                  onCancel={e => e!.stopPropagation()}
                >
                  <DeleteOutlined
                    key="setting"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  />
                </Popconfirm>,
                <ExportOutlined
                  key="export"
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onExport(item.id);
                  }}
                />,
              ]}
              hoverable={true}
            >
              <Card.Meta
                avatar={<FileTextFilled style={{ color: '#286FDC', fontSize: 20 }} />}
                title={item.name}
                key={item.id}
                description={
                  <div className="text-xs">
                    <div className="line-clamp-2 break-words h-8">{item.welcome}</div>
                    <div className="mt-2 text-right">
                      最近编辑：{dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </div>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
      {visible && (
        <EditApplication
          data={editData}
          isEdit={!!editData}
          updateFn={updateFn}
          onCancel={() => {
            setVisible(false);
            setEditData(undefined);
          }}
        />
      )}
    </div>
  );
};

export default ApplicationList;
